/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

const microNoteExport = Vue.resource('micro_notes/export{/id}');

export default microNoteExport;



// WEBPACK FOOTER //
// ./src/resources/microNoteExport.js